export const DATE_FORMAT = 'yyyy-MM-dd';

export const APP_ID_KEY = 'app_id';
export const AUTH_CONNECTOR_KEY = 'auth_connector';
export const SESSION_ID_KEY = 'session_id';
export const INTENT_LESS_KEY = 'intent_less';
export const CHANNEL_KEY = 'channel';
export const ACCESS_KEY = 'access-key';
export const AUTH_REQUEST_STATE_KEY = 'auth-request-state';
export const AUTH_CONFIG_KEY = 'auth-config';
export const AUTH_KEY = 'auth';
export const NON_WEB_STATE = 'non-web';

export const WEB_CHANNEL = 'web';
export const WHATSAPP_CHANNEL = 'whatsapp';
export const FB_CHANNEL = 'fb';